export * from './decoration.component';
